import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * VERUM Q — SEO meta-tag component
 *
 * Central source of truth for canonical URL, brand name, and default
 * description. The CANONICAL_HOST constant is what every page's
 * canonical and og-url resolves to, regardless of whichever domain
 * the page is currently served under (modusnode.com → verumq.com 301
 * redirect handles the legacy domain at the edge).
 *
 * History: pre-DNS-cut, this pointed at modusnode.com. Cut completed
 * 2026-05-06.
 */

// The host we treat as canonical for SEO. www-prefixed because that's
// the public-facing canonical (apex verumq.com 301-redirects to www).
const CANONICAL_HOST = 'https://www.verumq.com';

const BRAND = 'Verum Q';
const DEFAULT_DESC = 'Verum Q reads what you write and shows you the gap between stated and lived. Not a wellness app. An instrument.';

export default function SEO({
  title = 'Verum Q — Infrastructure for honesty',
  description = DEFAULT_DESC,
  path = '/',
  image = `${CANONICAL_HOST}/og-cover.png`,
  noIndex = false
}) {
  const url = CANONICAL_HOST + path;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={BRAND} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
